module.exports = __webpack_public_path__ + "static/media/ic_visa.6534ebc2.svg";